import React from 'react';
import { useBodyScrollLock } from '../../../hooks/useBodyScrollLock';
import { Button, ModalHeader, ModalBody, Row, Col } from 'reactstrap';
import Rodal from '../../../components/Rodal/Rodal';
import './ProcessAboutModal.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';

interface ProcessAboutModalProps {
    isVisible: boolean;
    closeModal: () => void;
}
const ProcessAboutModal = (props: ProcessAboutModalProps) => {
    useBodyScrollLock();

    return (
        <Rodal
            className="about-process-modal"
            visible={props.isVisible}
            onClose={() => props.closeModal()}
            animation={'fade'}
            showMask={true}>
            <div className="pdetail-header">
                <ModalHeader>About The Process</ModalHeader>
            </div>

            <ModalBody className="about-process-body">
                <p>
                    Each engagement is designed to be as efficient, transparent
                    and affordable as possible. It involves mulitple parties,
                    including a single seller and one or more potential buyers
                    and is designed to protect the seller's interest at every
                    step in the engagement. There are six stages to each
                    engagement, where each stage has between 10 and 13 steps
                    where a step represents a deliverable by one of types of
                    parties (Buyer, Seller, VetValue). The engagement is managed
                    to minimize the probability of any party wasting another
                    party's time. Thus, the process is operated much like a hand
                    of poker, where each player is required to "ante up" at
                    certain critical stages in order to proceed further in the
                    process.
                </p>
                <div className="process-steps">
                    <p className="overflow-container">
                        <Row className="align-items-center">
                            <Col md={8}>The major process stages include:</Col>
                            <Col md={4}>
                                <div>"Ante up" fee</div>

                                <Row>
                                    <Col md={6}>Seller</Col>
                                    <Col md={6}>Buyer</Col>
                                </Row>
                            </Col>
                        </Row>

                        <Row>
                            <Col md={8}>
                                <ul>
                                    <li>
                                        Anonymously establishing buyer awareness
                                        of the seller
                                    </li>
                                </ul>
                            </Col>
                            <Col md={4}></Col>
                        </Row>

                        <Row>
                            <Col md={8}>
                                <ul>
                                    <li>
                                        Execution of an ID NDA by interested
                                        buyers selected by seller and disclosure
                                        of indentity to same
                                    </li>
                                </ul>
                            </Col>
                            <Col md={4}>
                                <Row>
                                    <Col md={6}>
                                        <FontAwesomeIcon
                                            icon={faCheck}
                                            className="check-icon"
                                        />
                                    </Col>
                                    <Col md={6}>
                                        <FontAwesomeIcon
                                            icon={faCheck}
                                            className="check-icon"
                                        />
                                    </Col>
                                </Row>
                            </Col>
                        </Row>

                        <Row>
                            <Col md={8}>
                                <ul>
                                    <li>
                                        Execution of a Data NDA by interested
                                        buyers selected by seller and provision
                                        of investment presentation
                                    </li>
                                </ul>
                            </Col>
                            <Col md={4}>
                                <Row>
                                    <Col md={6}>
                                        <FontAwesomeIcon
                                            icon={faCheck}
                                            className="check-icon"
                                        />
                                    </Col>
                                    <Col md={6}>
                                        <FontAwesomeIcon
                                            icon={faCheck}
                                            className="check-icon"
                                        />
                                    </Col>
                                </Row>
                            </Col>
                        </Row>

                        <Row>
                            <Col md={8}>
                                <ul>
                                    <li>
                                        Expression of interest with preliminary
                                        indicative valaution range by buyer(s)
                                    </li>
                                </ul>
                            </Col>
                            <Col md={4}>
                                <Row>
                                    <Col md={6}></Col>
                                    <Col md={6}>
                                        <FontAwesomeIcon
                                            icon={faCheck}
                                            className="check-icon"
                                        />
                                    </Col>
                                </Row>
                            </Col>
                        </Row>

                        <Row>
                            <Col md={8}>
                                <ul>
                                    <li>
                                        Provision of Detailed Financial Model to
                                        interested buyers selected by seller
                                    </li>
                                </ul>
                            </Col>
                            <Col md={4}>
                                <Row>
                                    <Col md={6}>
                                        <FontAwesomeIcon
                                            icon={faCheck}
                                            className="check-icon"
                                        />
                                    </Col>
                                    <Col md={6}></Col>
                                </Row>
                            </Col>
                        </Row>

                        <Row>
                            <Col md={8}>
                                <ul>
                                    <li>
                                        Expression of interest with updated
                                        indicative valuation range by buyer
                                    </li>
                                </ul>
                            </Col>
                            <Col md={4}>
                                <Row>
                                    <Col md={6}></Col>
                                    <Col md={6}>
                                        <FontAwesomeIcon
                                            icon={faCheck}
                                            className="check-icon"
                                        />
                                    </Col>
                                </Row>
                            </Col>
                        </Row>

                        <Row>
                            <Col md={8}>
                                <ul>
                                    <li>
                                        In-person and/or virtual meetings with
                                        each buyer
                                    </li>
                                </ul>
                            </Col>
                            <Col md={4}>
                                <Row>
                                    <Col md={6}></Col>
                                    <Col md={6}>
                                        <FontAwesomeIcon
                                            icon={faCheck}
                                            className="check-icon"
                                        />
                                    </Col>
                                </Row>
                            </Col>
                        </Row>

                        <Row>
                            <Col md={8}>
                                <ul>
                                    <li>
                                        Buyer LOI submissions and selection by
                                        seller
                                    </li>
                                </ul>
                            </Col>
                            <Col md={4}>
                                <Row>
                                    <Col md={6}></Col>
                                    <Col md={6}></Col>
                                </Row>
                            </Col>
                        </Row>
                    </p>
                </div>
                <p>
                    Seller may select any one of three different engagement
                    tempos: slow, medium, fast. Each tempo offers a different
                    amount of time for the buyer and/or seller to comply with
                    the requirements of that step. If a buyer does not complete
                    a step on a timely basis, the buyer is dropped from the
                    process. Because the seller is integral to the process and
                    controls the tempo, a seller is penalized, rather than
                    dropped from the process, if they fail to complete a given
                    step's requirements on a timely basis. This penalty is
                    leveid in the form of a late fee, which is neither
                    refundable nor creditable. Late fees are utilized
                    exclusively to encourage seller compliance with the tempo
                    they themselves selected. A seller may revise, at any point
                    in the process, the tempo for the remainder of the
                    engagement. The seller has the option to suspend the
                    engagement at any time for whatever period of time they so
                    desire. Monthly suspention fees apply.
                </p>
                <p>
                    The engagement process provides a dedicated communication
                    environment to facilitate private communication between any
                    engaged buyer and the seller. Each unique buyer-seller
                    communication environment is designed to be private and
                    secure, to promote efficient and transparent dialog and to
                    optimize counter-party accountability, both during the
                    practice sales process and thereafter. Each such environment
                    includes:
                    <ul>
                        <li>A multi-threaded discussion board</li>
                        <li>
                            A virtual meeting environment for one-on-one
                            meetings
                        </li>
                        <li>
                            An organized, access-managed data and documents
                            repository, to be used for the Due Diligence process
                            after an LOI is selected
                        </li>
                    </ul>
                </p>
                <p>
                    After an LOI is executed with a buyer, these communications
                    referrence above support the seller's outside legal counsel
                    as it negotiates definitive transaction documents with that
                    buyer. The closing of the transaction will occur once the
                    buyer has determined that it has completed its due diligence
                    and the buyer and seller finalize the drafting of the
                    transaction documents. Upon execution of the transaction,
                    the transaction fee, net of all relevant credits, is paid by
                    the seller to VetValue in the form of a wire transfer at
                    closing.
                </p>

                <p>
                    Discount brokerage clients have access to timely, US-based
                    administrative support, via the platform's direct messaging
                    feature, for technical support
                </p>
                <p>
                    Full service brokerage clients also benefit from the advice
                    and assistance of the VetValue advisor dedicated to the
                    seller's engagement in the following ways:
                    <ul>
                        <li>
                            The advisor enhances the quality of the investment
                            summary and detailed financial model provided to
                            buyers.
                        </li>
                        <li>
                            The advisor supervises all buyer / seller
                            communications on the platform in order to best
                            protect the seller's interests.
                        </li>
                        <li>
                            The advisor enhances the quality of the comparative
                            LOI analysis provided to the seller.
                        </li>
                        <li>
                            The advisor provides guidance, advice and
                            perspective to the client throughout the proces, as
                            well as any administrative support related to the
                            client's use of the platform.
                        </li>
                    </ul>
                </p>
            </ModalBody>
            <Button className="cancel-btn" onClick={() => props.closeModal()}>
                Close
            </Button>
        </Rodal>
    );
};

export default ProcessAboutModal;
